import React from 'react';
import './App.css';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
// Importation des pages
import Home from './pages/Home'; 
import Apropos from './pages/Apropos';
import Galerie from './pages/Galerie';
import Contact from './pages/Contact';
import Evenement from './pages/Evenement';


function App() {
  return (
    <Router>
      <Routes>
        {/* Définir la route pour la page Home */}
        <Route path="/" element={<Home />} />
        <Route path="/apropos" element={<Apropos />} />
        <Route path="/galerie" element={<Galerie />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/evenement" element={<Evenement />} />
      </Routes>
    </Router>
  );
}

export default App;
